export function passwordContainsUpperAndLowerCase(password: string) {
  const upperCaseRegex = /[A-Z]/;
  const lowerCaseRegex = /[a-z]/;
  if (upperCaseRegex.test(password) && lowerCaseRegex.test(password)) {
    return true;
  }
  return false;
}

export function passwordContainsSpecialCharacter(password: string) {
  const specialCharsRegex = /[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/;
  return specialCharsRegex.test(password);
}

export function passwordContainsNumber(password: string) {
  const numbersRegex = /\d/;
  return numbersRegex.test(password);
}

export function validatePassword(password: string) {
  return passwordContainsSpecialCharacter(password)
      && password.length > 7
      && passwordContainsUpperAndLowerCase(password)
      && passwordContainsNumber(password);
}
